import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import FormikHelper from '../../../../../utilities/helpers/FormikHelper';
import { useFormik } from 'formik';
import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import OtpPopup from '../AuthComponents/OtpPopup';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { userPhoneValidations } from '../networking';
import { toast, ToastContainer } from 'react-toastify';
import CustomToast from '../../../common/CustomToast.js';
import 'react-toastify/dist/ReactToastify.css';
import { useCookies } from '../../../../../utilities/hooks/UseCookie.js';
import { useHistory } from 'react-router-dom';

const WizardProfileForm = (props) => {
	const dictionary = useDictionary();
	const [showForm, setShowForm] = useState(false);
	const [showOtpModal, setShowOtpModal] = useState(false);
	const phoneUtil = PhoneNumberUtil.getInstance();
	const [_, __, deleteCookies] = useCookies();
	const history = useHistory();

	const onLogoutClicked = () => {
		history.push('/logout');
		deleteCookies();
	};

	const wizardProfileSchema = Yup.object().shape({
		first_name: Yup.string().required(dictionary.first_name_required),
		last_name: Yup.string().required(dictionary.last_name_required),
		phone: Yup.string().required(dictionary.mobile_number_required)
			.test('is-valid-phone', dictionary.invalid_phone_number, (value) => {
				try {
					const phoneNumber = phoneUtil.parseAndKeepRawInput('+'+value)
					return phoneUtil.isValidNumber(phoneNumber);
				} catch (error) {
					return false;
				}
			})
	});

	const formik = useFormik({
		initialValues: {
			first_name: props.details.first_name,
			last_name: props.details.last_name,
			phone: props.details.phone
		},
		onSubmit: (values) => {
			let newDetails = Object.assign({}, props.details);
			newDetails.first_name = values.first_name;
			newDetails.last_name = values.last_name;
			newDetails.phone = values.phone;

			props.setDetails(newDetails);
			
			props.setShowLoader(true);
			userPhoneValidations({
				phone: `+${values.phone}`
			}).then((response) => {
				let res = response.data;

				if (res.is_confirmed) {
					onOtpVerified('success')
					props.setShowLoader(false);
					return;
				}
			
				if (res.can_send_otp) {
					setShowOtpModal(true);
					props.setShowLoader(false);
					return;
				}

				if(res.logged_in) {
					toast.error(<CustomToast message={res?.message ?? dictionary.general_error} />, {
						position: 'top-right',
						autoClose: 5000,
						toastId: `otp-1-1`,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: false,
						progress: undefined,
						closeButton: false,
						icon: false,
						className: 'toast-white-warning',
					});
					setTimeout(()=>{
						onLogoutClicked();
					},2000)
					return;
				}

				if(res.is_confirmed === false && res.can_send_otp === false && res.logged_in === false) {
					toast.error(<CustomToast message={res?.message ?? dictionary.general_error} />, {
						position: 'top-right',
						autoClose: 5000,
						toastId: `otp-1-1`,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: false,
						draggable: false,
						progress: undefined,
						closeButton: false,
						icon: false,
						className: 'toast-white-warning',
					});
					setTimeout(()=>{
						onLogoutClicked();
					},2000)
				}
			}).catch((error) => {
				toast.error(<CustomToast message={error?.response?.data?.message ?? dictionary.general_error} />, {
					position: 'top-right',
					autoClose: 5000,
					toastId: `otp-1-1`,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: false,
					draggable: false,
					progress: undefined,
					closeButton: false,
					icon: false,
					className: 'toast-white-warning',
				});
				setTimeout(()=>{
					onLogoutClicked();
				},2000)
				console.error(error);
			});		
		},
		validateOnMount: true,
		validationSchema: wizardProfileSchema
	});

	FormikHelper.setFormik(formik);

	useEffect(() => {
		setTimeout(() => setShowForm(true), 100);
	}, []);

	const onOtpVerified = (status) => {
		if (status == 'success') {
			props.setStep(2);
		}
		setShowOtpModal(false);
	};

	return (
		<>
		<form
			style={{ opacity: showForm ? '1' : '0', overflowY: 'auto' }}
			className="login-form-content-container transparent-form thin-scrollbar"
			onSubmit={formik.handleSubmit}
		>
			<h1>{dictionary.lets_setup}</h1>
			{/* <div className="text">{dictionary.step1_message}</div> */}
			{FormikHelper.getInputTemplate(
				'first_name',
				dictionary.first_name,
				'John',
				'text',
				true,
				true
			)}
			{FormikHelper.getInputTemplate(
				'last_name',
				dictionary.last_name,
				'Wick',
				'text',
				true,
				true
			)}
			{FormikHelper.getPhoneNumberInputTemplate(
				'phone',
				dictionary.Mobile_Number,
				'697123456789',
				'phone',
				true,
				true
			)}

			<div className="group-inputs" style={{ marginTop: '30px' }}>
				<button
					data-testid="continue-button"
					type="submit"
					className={formik.isValid ? 'button' : 'button button-disabled'}
				>
					{dictionary.continue}
				</button>
			</div>
		</form>
		{showOtpModal && (
			<OtpPopup
				setShowModal={setShowOtpModal}
				onActionFinished={onOtpVerified}
				asyncTask={formik.submitForm}
				title={dictionary.otp_verification_title}
				message={dictionary.otp_verification_message}
				phoneNumber={formik.values.phone}
			/>
		)}
		<div id="recaptcha-container"></div>
		<ToastContainer/>
		</>
	);
};

WizardProfileForm.propTypes = {
	details: PropTypes.object.isRequired,
	setDetails: PropTypes.func.isRequired,
	setStep: PropTypes.func.isRequired,
	setShowLoader: PropTypes.func.isRequired,
};

export default WizardProfileForm;
